import * as React from 'react';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemIntegrityStatusProps extends ComponentProps, FactItemProps {
  integrityScore: number;
  integrityStatus: ComplexValue<number>;
}

export const IntegrityStatusFactItem = (props: FactItemIntegrityStatusProps) => {
  const { integrityStatus, integrityScore, title, url, linkDomain, portalTarget } = props;
  const iconIntegrityStatus = integrityStatus && (
    <Icon url={integrityStatus.icon} />
  );

  const score = integrityScore ? integrityScore as number: undefined;
  const items = [{ value: score, tooltip: integrityStatus?.description }];

  if (!integrityStatus?.value) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={iconIntegrityStatus}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
